import { render, staticRenderFns } from "./RegistroArmaNuevaDialogComponent.vue?vue&type=template&id=d7be516e"
import script from "./RegistroArmaNuevaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroArmaNuevaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports